module.exports = __webpack_public_path__ + "static/media/Sandeep.716750aa.png";